export const ROUTE_PATH = '/parking-tower-stop-list/add';

export const FEATURE_NAME = 'parkingTowerStopListAddPage';
